import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

export const MaybeFaireDirectBrandBannerImage: React.FC = () => {
  const { faireDirectBrand } = useFaireDirectBrand();

  const bannerImage = optimizeImageUrl(
    faireDirectBrand?.banner_image ?? {},
    false,
    { height: 120 }
  );

  if (!bannerImage) {
    return null;
  }

  return (
    <ImageContainer>
      <img src={bannerImage} alt="" />
    </ImageContainer>
  );
};

const ImageContainer = styled.div`
  width: 100%;

  height: 120px;
  ${responsiveMediaQueries.mobile} {
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
